import { Container, styled } from '@mui/material'
import { ResponsiveContainer } from 'recharts'

const StyledPieLabel = styled(Container)({
  textAlign: 'center',
  position: 'absolute',
  top: '40%',
  bottom: 0,
  left: '5px',
  right: 0,
})

const ResponsiveStyledContainer = styled(ResponsiveContainer)({
  position: 'relative',
})
export { StyledPieLabel, ResponsiveStyledContainer }
